import React from 'react'

function Appointments() {
  return <div>Appointments</div>
}

export default Appointments
